import http from "../../axiosSetup";

class WellnessMetadataService {
  static getAll() {
    return http.get("/wellnesses").then((response) => response.data);
  }
}
export default WellnessMetadataService;
